export default __webpack_public_path__ + "static/media/placeholder-image.ea87cfce.webp";